<template>
  <page content-class="admin-campaign-list">
      <!-- Top-Level Settings Bar -->
      <b-card no-body class="campaign-settings-menu bg-light px-4 pt-3 pb-2 mt-3">
        <div class="d-flex justify-content-between pb-1">
          <h3><strong>Settings</strong></h3>
          <div class="d-flex justify-content-end align-items-center">
            <span
              @click="$router.push({ name: 'EmailSetup' })"
              class="mr-4"
            >
              Connect Email
            </span>
            <span
              @click="$router.push({ name: 'EmailSignature' })"
              class="mr-4"
            >
              Edit Email Signature
            </span>
            <span
              class="text-primary font-weight-bold"
            >
              Add Collective Goal
            </span>
          </div>
        </div>
      </b-card>
      <b-card body-class="p4" class="mt-3">
        <b-row class="justify-content-center">
          <b-col cols="12" sm="12" xs="12">
            <div class="pb-2 pt-1 pl-1">
              <h3>Add a Collective Goal</h3>
              <p class="text-dark">Fill in this form to add a Collective Goal to your dashboard</p>
            </div>
            <update-collective-goal
              :value="form"
              @input="updateCollectiveGoal($event)"
            />
          </b-col>
        </b-row>
      </b-card>
    </page>
</template>

<script>
import Page from '@/components/campaign-admin/page';
import UpdateCollectiveGoal from '@/components/campaign-admin/update-collective-goal.vue';
import UpdateCollectiveGoalMutation from '@/graphql/mutations/UpdateCollectiveGoal.gql';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page,
    UpdateCollectiveGoal
  },
  data: () => ({
    form: {
      collectiveGoal: null
    },
  }),
  computed: {
    ...mapRoot([ 'company' ]),
  },
  created() {
    console.log('Company', this.company.collectiveGoal);
    if (this.company && this.company.collectiveGoal) {
      this.form.collectiveGoal = { ...this.company.collectiveGoal };
    }
  },
  methods: {
    async updateCollectiveGoal(update) {
      try {
        this.$log.debug({ update });

        await this.$apollo.mutate({
          mutation: UpdateCollectiveGoalMutation,
          variables: { update },
        });

        this.$notification({ message: 'Collective goal has been saved successfully', variant: 'success' });
      } catch (error) {
        this.$notifyErr(error, { prepend: 'Failed to save collective goal.' });
        console.log(error);
      }
      console.log('UPDATE FROM NEW COMPNENT: ', update);
    },
  },
};
</script>

<style lang="scss">
  .referral-jam-event-settings {
      .event-logo {
          max-height: 30px;
          max-width: 200px;
      }
  }
  .campaign-settings-menu {
    div > span:hover {
      cursor: pointer;
      font-weight: 600;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/campaign-admin/SettingsCollectiveGoal.vue